'use client';

import { c as _c } from "react/compiler-runtime";
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { Box, Typography } from '@mui/material';
import Link from 'next/link';
import { v4 as uuid } from 'uuid';
import type { MainSubnavItemType } from './types';
import { getIcon } from './utils';
type MainSubnavItemProps = {
  analyticsProps: {
    impressionPosition: number;
    parentActivityId: string;
  };
  item: MainSubnavItemType;
  selected: boolean;
};
export const MainSubnavItem = t0 => {
  const $ = _c(39);
  const {
    analyticsProps,
    item,
    selected
  } = t0;
  let t1;
  if ($[0] !== item.iconType) {
    t1 = getIcon(item.iconType);
    $[0] = item.iconType;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const Icon = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = uuid();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== item.href) {
    t3 = item.href.split("/").pop();
    $[3] = item.href;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = {
      sub_nav_category: t3,
      sub_nav_section: "main"
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${typeof window !== "undefined" && window.location.origin}${item.href}`;
  let t6;
  if ($[7] !== analyticsProps.impressionPosition || $[8] !== analyticsProps.parentActivityId || $[9] !== t4 || $[10] !== t5) {
    t6 = {
      actionName: "sub_nav_interaction",
      actionSection: "cc_sub_nav",
      actionType: "navigate",
      activityId: t2,
      additionalAttributes: t4,
      impressionPosition: analyticsProps.impressionPosition,
      parentActivityId: analyticsProps.parentActivityId,
      targetPageURL: t5
    };
    $[7] = analyticsProps.impressionPosition;
    $[8] = analyticsProps.parentActivityId;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const firePageAction = usePageAction(t6);
  let t7;
  if ($[12] !== firePageAction) {
    t7 = () => {
      firePageAction();
    };
    $[12] = firePageAction;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const handleClick = t7;
  let t8;
  if ($[14] !== Icon || $[15] !== selected) {
    t8 = <Icon selected={selected} />;
    $[14] = Icon;
    $[15] = selected;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      fontSize: {
        xs: "11px",
        sm: "14px"
      },
      display: "flex",
      color: "inherit",
      fontWeight: "500",
      textWrap: "nowrap"
    };
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== item.label) {
    t10 = <Typography sx={t9}>{item.label}</Typography>;
    $[18] = item.label;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const content = t11;
  const t12 = selected ? "greens.main" : "transparent";
  const t13 = selected ? "greens.main" : "neutral.darker";
  let t14;
  if ($[23] !== selected) {
    t14 = !selected && {
      "&:hover": {
        borderColor: "grey.300"
      }
    };
    $[23] = selected;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      outlineColor: "blues.light",
      position: "relative",
      zIndex: 999
    };
    t16 = {
      textDecoration: "none",
      color: "inherit",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "4px"
    };
    $[25] = t15;
    $[26] = t16;
  } else {
    t15 = $[25];
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t12 || $[28] !== t13 || $[29] !== t14) {
    t17 = {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      paddingY: "8px",
      textAlign: "center",
      alignItems: "center",
      minWidth: "60px",
      height: "100%",
      borderBottom: "2px solid",
      borderColor: t12,
      color: t13,
      ...t14,
      "&.Mui-focusVisible": t15,
      "& a": t16
    };
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== content || $[32] !== handleClick || $[33] !== item.href || $[34] !== selected) {
    t18 = selected ? content : <Link href={item.href} onClick={handleClick}>{content}</Link>;
    $[31] = content;
    $[32] = handleClick;
    $[33] = item.href;
    $[34] = selected;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t17 || $[37] !== t18) {
    t19 = <Box sx={t17}>{t18}</Box>;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  return t19;
};